import classNames from "classnames";
import React, { useState } from "react";

import { useSelector } from "../../utils/hooks";

import { Product } from "./Product";

import "./ProductsList.scss";

export const ProductsList = () => {
	const [activeGroupIndex, setActiveGroupIndex] = useState(0);
	const recommendedProductsGroups = useSelector(
		(state) => state.popup.products.recommendedProducts.products,
	);

	const recommendedProductsHeader = useSelector(
		(state) => state.popup.recommendedProductsHeader,
	);

	return (
		<>
			{recommendedProductsGroups.length > 0 && (
				<section className="addtocart-recommendedProductsList">
					<h2
						className="addtocart-recommendedProducts__heading"
						id="recommendedProducts__heading"
					>
						{recommendedProductsHeader}
					</h2>
					<div className="addtocart-recommendedProductsList-groups">
						{recommendedProductsGroups.map((group, index) => (
							<button
								className={classNames({
									"addtocart-recommendedProductsList-group-button": true,
									"addtocart-recommendedProductsList-group-button__active":
										activeGroupIndex === index,
								})}
								key={group.groupName}
								onClick={() => setActiveGroupIndex(index)}
							>
								{group.groupName}
							</button>
						))}
					</div>
					<div className="addtocart-recommendedProductsContainer">
						<div className="addtocart-list">
							<ul
								className="addtocart-list__wrapper"
								data-testid="products-list"
							>
								{recommendedProductsGroups[activeGroupIndex]?.items?.map(
									(product, i) => (
										<Product
											product={product}
											key={`${product.regionalProductSku}-${i}`}
											index={i}
										/>
									),
								)}
							</ul>
						</div>
					</div>
				</section>
			)}
		</>
	);
};
